// /posts 게시판 유형 코드 → 라벨 / 색 매핑 (route-local 도메인 지식).

import type { StatusChipColor } from "components/list";

interface StatusMeta {
  label: string;
  color: StatusChipColor;
}

// 게시판 유형(boardKind)
export const boardKindMeta: Record<string, StatusMeta> = {
  NORMAL: { label: "이야기", color: "default" },
  ALBUM: { label: "포토앨범", color: "primary" },
  AGENDA: { label: "알림장", color: "info" },
  MEAL: { label: "식단표", color: "success" },
};

// 매핑에 없는 값도 안전하게 표시
export const resolveStatusMeta = (
  map: Record<string, StatusMeta>,
  value: unknown
): StatusMeta => {
  const key = value === null || value === undefined ? "" : String(value);
  return map[key] ?? { label: key || "-", color: "default" };
};
